import classNames from "classnames";
import type { IconComponentType } from "../../../ui/Icon/Icon";
import styles from "./NavigationItemContent.module.css";

interface NavigationItemContentProps {
  title: string;
  IconComponent?: IconComponentType;
  isActive: boolean;
}

function NavigationItemContent({
  title,
  IconComponent,
  isActive,
}: NavigationItemContentProps) {
  return (
    <>
      {IconComponent ? (
        <span
          className={classNames(styles.icon, {
            [styles.active]: isActive,
          })}
        >
          <IconComponent size="large" />
        </span>
      ) : null}
      <span>{title}</span>
    </>
  );
}

export default NavigationItemContent;
